import React from 'react';
import PageWrapper from 'components/ui/PageWrapper';
import { Link } from 'react-router-dom';

//A temporary error page for login errors now, needs to be styled
const Error = () => {
  return (
    <PageWrapper>
      Error logging in. <br />
      There is an error trying to log you in, please try again.
      <br />
      <Link to="/">Go Back</Link>
    </PageWrapper>
  );
};

export default Error;
